import { h, Host } from '@stencil/core';
import cn from 'classnames';
import { ETabType, scrollToComponent, isHostnameContainsCC, getBodyCountryCode, getBodyLanguageCode, store, setLinearProductData, ACTION_TYPES, tryParse } from '@pes-ui/utils';
import { observeIntersectionWithHeader, setStickyBarTab, setTabActive, } from '../../../globals/stickyBar.utils';
import NotificationBannerController from '../../UI/pes-notification-banner/controller';
const HIDE_TIMEOUT = 5000;
const DocumentType = {
  DOCUMENT: 'DOCUMENT',
  SOFTWARE: 'SOFTWARE',
};
export class ProductDocumentsAndSoftware {
  constructor() {
    this.notificationController = new NotificationBannerController(HIDE_TIMEOUT);
    this.softwareAndFirmwareRef = null;
    this.documentRef = null;
    this.documentLabel = undefined;
    this.softwareAndFirmwareLabel = undefined;
    this.productId = undefined;
    this.apiEndpoint = undefined;
    this.documentDetailsUrl = undefined;
    this.localeCode = undefined;
    this.idmsToken = undefined;
    this.view = 'smallcard';
    this.myDocumentsAddedLabel = undefined;
    this.myDocumentsRemovedLabel = undefined;
    this.myDocumentsUrl = undefined;
    this.myDocumentsCta = undefined;
    this.showMyDocuments = false;
    this.appSource = undefined;
    this.userProfile = undefined;
    this._documentLabel = undefined;
    this._softwareAndFirmwareLabel = undefined;
    this._productId = undefined;
    this._apiEndpoint = undefined;
    this._documentDetailsUrl = undefined;
    this._localeCode = undefined;
    this._idmsToken = undefined;
    this._view = undefined;
    this._myDocumentsAddedLabel = undefined;
    this._myDocumentsRemovedLabel = undefined;
    this._myDocumentsUrl = undefined;
    this._myDocumentsCta = undefined;
    this._showMyDocuments = undefined;
    this._appSource = undefined;
    this._userProfile = undefined;
    this.showDocuments = {
      [DocumentType.DOCUMENT]: true,
      [DocumentType.SOFTWARE]: true,
    };
    this.hasDocuments = {
      [DocumentType.DOCUMENT]: false,
      [DocumentType.SOFTWARE]: false,
    };
    this.documentsCount = this.getDocumentsCount();
  }
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    this.documentLabel = (_a = tryParse(this._documentLabel)) !== null && _a !== void 0 ? _a : this.documentLabel;
    this.softwareAndFirmwareLabel = (_b = tryParse(this._softwareAndFirmwareLabel)) !== null && _b !== void 0 ? _b : this.softwareAndFirmwareLabel;
    this.productId = (_c = tryParse(this._productId)) !== null && _c !== void 0 ? _c : this.productId;
    this.apiEndpoint = (_d = tryParse(this._apiEndpoint)) !== null && _d !== void 0 ? _d : this.apiEndpoint;
    this.documentDetailsUrl = (_e = tryParse(this._documentDetailsUrl)) !== null && _e !== void 0 ? _e : this.documentDetailsUrl;
    this.localeCode = (_f = tryParse(this._localeCode)) !== null && _f !== void 0 ? _f : this.localeCode;
    this.idmsToken = (_g = tryParse(this._idmsToken)) !== null && _g !== void 0 ? _g : this.idmsToken;
    this.view = (_h = tryParse(this._view)) !== null && _h !== void 0 ? _h : this.view;
    this.myDocumentsAddedLabel = (_j = tryParse(this._myDocumentsAddedLabel)) !== null && _j !== void 0 ? _j : this.myDocumentsAddedLabel;
    this.myDocumentsRemovedLabel = (_k = tryParse(this._myDocumentsRemovedLabel)) !== null && _k !== void 0 ? _k : this.myDocumentsRemovedLabel;
    this.myDocumentsUrl = (_l = tryParse(this._myDocumentsUrl)) !== null && _l !== void 0 ? _l : this.myDocumentsUrl;
    this.myDocumentsCta = (_m = tryParse(this._myDocumentsCta)) !== null && _m !== void 0 ? _m : this.myDocumentsCta;
    this.showMyDocuments = (_o = tryParse(this._showMyDocuments)) !== null && _o !== void 0 ? _o : this.showMyDocuments;
    this.appSource = (_p = tryParse(this._appSource)) !== null && _p !== void 0 ? _p : this.appSource;
    this.userProfile = this._userProfile || this.userProfile;
    store.dispatch(setLinearProductData({ ddc: {
        documentLabel: this.documentLabel,
        softwareAndFirmwareLabel: this.softwareAndFirmwareLabel,
        productId: this.productId,
        apiEndpoint: this.apiEndpoint,
        documentDetailsUrl: this.documentDetailsUrl,
        localeCode: this.localeCode,
        myDocumentsAddedLabel: this.myDocumentsAddedLabel,
        myDocumentsUrl: this.myDocumentsUrl,
        myDocumentsCta: this.myDocumentsCta,
        appSource: this.appSource,
        idmsToken: this.idmsToken,
        view: this.view,
        myDocumentsRemovedLabel: this.myDocumentsRemovedLabel,
        showMyDocuments: this.showMyDocuments,
        userProfile: this.userProfile,
      } }));
    this.unsubscribe = store.subscribe(() => {
      const { data, activeProductTab, lastActionType } = store.getState().product;
      if (lastActionType !== ACTION_TYPES.SET_ACTIVE_PRODUCT_TAB)
        return;
      if (!data[activeProductTab].ddc)
        return;
      const { documentLabel, softwareAndFirmwareLabel, productId, apiEndpoint, documentDetailsUrl, localeCode, myDocumentsAddedLabel, myDocumentsUrl, myDocumentsCta, appSource, } = data[activeProductTab].ddc;
      this.documentLabel = documentLabel;
      this.softwareAndFirmwareLabel = softwareAndFirmwareLabel;
      this.productId = productId;
      this.apiEndpoint = apiEndpoint;
      this.documentDetailsUrl = documentDetailsUrl;
      this.localeCode = localeCode;
      this.myDocumentsAddedLabel = myDocumentsAddedLabel;
      this.myDocumentsUrl = myDocumentsUrl;
      this.myDocumentsCta = myDocumentsCta;
      this.appSource = appSource;
      this.hasDocuments = {
        [DocumentType.DOCUMENT]: false,
        [DocumentType.SOFTWARE]: false,
      };
      this.showDocuments = {
        [DocumentType.DOCUMENT]: true,
        [DocumentType.SOFTWARE]: true,
      };
    });
  }
  observe(tabType) {
    if (tabType === ETabType.DDC_DOCUMENTS) {
      observeIntersectionWithHeader(this.documentRef, (entries) => {
        var _a;
        if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
          setTabActive({ type: ETabType.DDC_DOCUMENTS, title: this.documentLabel });
          this.setTabActive.emit();
        }
      });
    }
    else if (tabType === ETabType.DDC_SOFTWARE) {
      observeIntersectionWithHeader(this.softwareAndFirmwareRef, (entries) => {
        var _a;
        if ((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.isIntersecting) {
          setTabActive({ type: ETabType.DDC_SOFTWARE, title: this.softwareAndFirmwareLabel });
          this.setTabActive.emit();
        }
      });
    }
  }
  getDocumentsCount() {
    const documentMatches = document.cookie.match(/docref/g);
    return documentMatches ? documentMatches.length : 0;
  }
  async showBanner({ message, ctaLabel }) {
    const actions = ctaLabel
      ? {
        primary: {
          label: ctaLabel,
        },
      }
      : {};
    const notificationElement = await this.notificationController.show({
      target: 'header',
      componentProps: {
        active: true,
        status: "warning",
        actions,
        innerHTML: message,
      },
    });
    if (this.myDocumentsCta) {
      notificationElement.addEventListener('actionDidClick', () => {
        window.open(this.myDocumentsUrl, '_self');
      });
    }
  }
  onDocumentListingReady(e) {
    const { hasDocuments, name } = e.detail;
    this.hasDocuments = Object.assign(Object.assign({}, this.hasDocuments), { [DocumentType[name]]: hasDocuments });
    this.showDocuments = Object.assign(Object.assign({}, this.showDocuments), { [DocumentType[name]]: hasDocuments });
    if (this.hasDocuments[DocumentType.DOCUMENT]) {
      setStickyBarTab(ETabType.DDC_DOCUMENTS, [this.documentLabel]);
      this.observe(ETabType.DDC_DOCUMENTS);
    }
    if (this.hasDocuments[DocumentType.SOFTWARE]) {
      setStickyBarTab(ETabType.DDC_SOFTWARE, [this.softwareAndFirmwareLabel]);
      this.observe(ETabType.DDC_SOFTWARE);
    }
  }
  onDocumentFavoriteCountChange(e) {
    if (this.showMyDocuments) {
      const newDocumentsCount = e.detail;
      if (this.documentsCount < newDocumentsCount) {
        this.showBanner({
          message: this.myDocumentsAddedLabel,
          ctaLabel: this.myDocumentsCta,
        });
      }
      else if (this.documentsCount > newDocumentsCount) {
        this.showBanner({
          message: this.myDocumentsRemovedLabel,
        });
      }
      this.documentsCount = newDocumentsCount;
    }
  }
  getLocale() {
    var _a, _b;
    let country;
    let language;
    if (isHostnameContainsCC()) {
      country = getBodyCountryCode();
      language = getBodyLanguageCode();
    }
    else {
      const localeCode = (_a = this.localeCode) === null || _a === void 0 ? void 0 : _a.split('/').filter(Boolean);
      const VALID_AMOUNT_OF_CODES = 2;
      if (window.isApc && ((_b = this.localeCode) === null || _b === void 0 ? void 0 : _b.includes('apc'))) {
        localeCode === null || localeCode === void 0 ? void 0 : localeCode.shift();
      }
      if (localeCode && localeCode.length >= VALID_AMOUNT_OF_CODES) {
        [country, language] = localeCode;
      }
      else {
        country = '';
        language = '';
      }
    }
    return { country, language };
  }
  handleTabClicked(event) {
    if (this.documentRef && event.detail.title === this.documentLabel) {
      scrollToComponent(this.documentRef);
    }
    if (this.softwareAndFirmwareRef && event.detail.title === this.softwareAndFirmwareLabel) {
      scrollToComponent(this.softwareAndFirmwareRef);
    }
  }
  handlescrollToAllDocuments() {
    if (this.documentRef) {
      scrollToComponent(this.documentRef);
    }
  }
  handlescrollToSoftwareAndFirmware() {
    if (this.softwareAndFirmwareRef) {
      scrollToComponent(this.softwareAndFirmwareRef);
    }
  }
  renderDocumentsSection() {
    if (this.showDocuments[DocumentType.DOCUMENT]) {
      return (h("pes-collapsible-container", { class: cn({
          'product-documents': true,
          'product-documents--shown': this.hasDocuments[DocumentType.DOCUMENT],
        }), ref: (el) => (this.documentRef = el) }, h("qds-title", { slot: "header", class: "heading", level: "subsection", alignment: "start" }, this.documentLabel), h("div", { class: "content" }, h("pes-document-listing", { name: DocumentType.DOCUMENT, apiEndpoint: this.apiEndpoint, documentDetailsUrl: this.documentDetailsUrl, enableDocumentDetailsUrl: false, country: this.getLocale().country, language: this.getLocale().language, pageType: "product", resourceId: this.productId, software: false, myFavorites: this.showMyDocuments, idmsToken: this.idmsToken, view: this.view, applicationSource: this.appSource, userProfile: this.userProfile }))));
    }
  }
  renderSoftwareAndFirmwareSection() {
    if (this.showDocuments[DocumentType.SOFTWARE]) {
      return (h("pes-collapsible-container", { class: cn({
          'product-documents': true,
          'product-documents--shown': this.hasDocuments[DocumentType.SOFTWARE],
        }), ref: (el) => (this.softwareAndFirmwareRef = el) }, h("qds-title", { slot: "header", class: "heading", level: "subsection", alignment: "start" }, this.softwareAndFirmwareLabel), h("div", { class: "content" }, h("pes-document-listing", { name: DocumentType.SOFTWARE, apiEndpoint: this.apiEndpoint, documentDetailsUrl: this.documentDetailsUrl, enableDocumentDetailsUrl: false, country: this.getLocale().country, language: this.getLocale().language, pageType: "product", resourceId: this.productId, software: true, myFavorites: this.showMyDocuments, idmsToken: this.idmsToken, view: this.view, applicationSource: this.appSource, userProfile: this.userProfile }))));
    }
  }
  disconnectedCallback() {
    var _a;
    (_a = this.unsubscribe) === null || _a === void 0 ? void 0 : _a.call(this);
  }
  render() {
    return (h(Host, null, this.renderDocumentsSection(), this.renderSoftwareAndFirmwareSection()));
  }
  static get is() { return "pes-product-documents-and-software"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["product-documents-and-software.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["product-documents-and-software.css"]
    };
  }
  static get properties() {
    return {
      "documentLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "document-label",
        "reflect": false
      },
      "softwareAndFirmwareLabel": {
        "type": "any",
        "mutable": true,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "software-and-firmware-label",
        "reflect": false
      },
      "productId": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "product-id",
        "reflect": false
      },
      "apiEndpoint": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "api-endpoint",
        "reflect": false
      },
      "documentDetailsUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "document-details-url",
        "reflect": false
      },
      "localeCode": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "locale-code",
        "reflect": false
      },
      "idmsToken": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "idms-token",
        "reflect": false
      },
      "view": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "'grid' | 'list' | 'smallcard'",
          "resolved": "\"grid\" | \"list\" | \"smallcard\"",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "view",
        "reflect": false,
        "defaultValue": "'smallcard'"
      },
      "myDocumentsAddedLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "my-documents-added-label",
        "reflect": false
      },
      "myDocumentsRemovedLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "my-documents-removed-label",
        "reflect": false
      },
      "myDocumentsUrl": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "my-documents-url",
        "reflect": false
      },
      "myDocumentsCta": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "my-documents-cta",
        "reflect": false
      },
      "showMyDocuments": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "show-my-documents",
        "reflect": false,
        "defaultValue": "false"
      },
      "appSource": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "app-source",
        "reflect": false
      },
      "userProfile": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "user-profile",
        "reflect": false
      },
      "_documentLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-document-label",
        "reflect": false
      },
      "_softwareAndFirmwareLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-software-and-firmware-label",
        "reflect": false
      },
      "_productId": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-product-id",
        "reflect": false
      },
      "_apiEndpoint": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-api-endpoint",
        "reflect": false
      },
      "_documentDetailsUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-document-details-url",
        "reflect": false
      },
      "_localeCode": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-locale-code",
        "reflect": false
      },
      "_idmsToken": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-idms-token",
        "reflect": false
      },
      "_view": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-view",
        "reflect": false
      },
      "_myDocumentsAddedLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-my-documents-added-label",
        "reflect": false
      },
      "_myDocumentsRemovedLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-my-documents-removed-label",
        "reflect": false
      },
      "_myDocumentsUrl": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-my-documents-url",
        "reflect": false
      },
      "_myDocumentsCta": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-my-documents-cta",
        "reflect": false
      },
      "_showMyDocuments": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-show-my-documents",
        "reflect": false
      },
      "_appSource": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-app-source",
        "reflect": false
      },
      "_userProfile": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-user-profile",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "showDocuments": {},
      "hasDocuments": {},
      "documentsCount": {}
    };
  }
  static get events() {
    return [{
        "method": "setTabActive",
        "name": "setTabActive",
        "bubbles": true,
        "cancelable": true,
        "composed": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        }
      }];
  }
  static get listeners() {
    return [{
        "name": "documentListingReady",
        "method": "onDocumentListingReady",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "documentFavoriteCountChange",
        "method": "onDocumentFavoriteCountChange",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "tabClicked",
        "method": "handleTabClicked",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "scrollToAllDocuments",
        "method": "handlescrollToAllDocuments",
        "target": "window",
        "capture": false,
        "passive": false
      }, {
        "name": "scrollToSoftwareAndFirmware",
        "method": "handlescrollToSoftwareAndFirmware",
        "target": "window",
        "capture": false,
        "passive": false
      }];
  }
}
